let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1Bya1")).then(() => parcelRequire('jyFo7'));